// Mock data for PetWoodArt clone

export const STYLES = [
  {
    id: "tu-foto",
    name: "Tu Foto",
    description:
      "¿Ya tienes la imagen perfecta? La imprimimos tal cual en el taco de madera blanca, sin ningún retoque artístico. Resolución mínima recomendada: 1500×1000 px.",
    image:
      "https://media.base44.com/images/public/6939f5b5911fbf7e6ebf8768/40ed05891_IMG_4266.jpg",
    size: "20×15×3 cm",
    price: "29,50€",
  },
  {
    id: "acuarela",
    name: "Acuarela",
    description:
      "Delicadas transparencias y colores que fluyen suavemente, creando un retrato etéreo y elegante.",
    image:
      "https://base44.app/api/apps/6939f5b5911fbf7e6ebf8768/files/public/6939f5b5911fbf7e6ebf8768/caae2ff84_kiroacuarela.png",
    size: "20×15×3 cm",
    price: "29,50€",
  },
  {
    id: "ilustracion",
    name: "Ilustración",
    description:
      "Estilo vibrante y detallado que da vida a tu mascota con un toque artístico único.",
    image:
      "https://base44.app/api/apps/6939f5b5911fbf7e6ebf8768/files/public/6939f5b5911fbf7e6ebf8768/5ef7c6502_Kiroilustracin.png",
    size: "20×15×3 cm",
    price: "29,50€",
  },
  {
    id: "oleo",
    name: "Óleo",
    description:
      "Técnica tradicional con texturas ricas y profundidad. Un retrato digno de museo para tu compañero.",
    image:
      "https://customer-assets.emergentagent.com/job_pet-portraits-4/artifacts/e04nbtpz_oleo.png",
    size: "20×15×3 cm",
    price: "29,50€",
  },
  {
    id: "pop-art",
    name: "Pop Art",
    description:
      "Una explosión de color que captura la energía y alegría de tu mascota. Salpicaduras vibrantes y trazos llenos de vida que transforman su retrato en una obra contemporánea única.",
    image:
      "https://customer-assets.emergentagent.com/job_pet-portraits-4/artifacts/4i9p2xiw_kiro%20pop%20art%20nuevo.png",
    size: "20×15×3 cm",
    price: "29,50€",
  },
  {
    id: "carboncillo",
    name: "Carboncillo",
    description:
      "Trazos expresivos y contrastes profundos con la técnica del carboncillo, capturando cada detalle con una elegancia atemporal.",
    image:
      "https://media.base44.com/images/public/6939f5b5911fbf7e6ebf8768/b7ee7de66_Carboncillo.png",
    size: "20×15×3 cm",
    price: "29,50€",
  },
  {
    id: "anime",
    name: "Anime",
    description:
      "Estilo inspirado en el manga japonés con rasgos expresivos, colores vibrantes y un toque único de fantasía.",
    image:
      "https://customer-assets.emergentagent.com/job_pet-portraits-4/artifacts/t8893998_d40e5f09b_kiroanime.jpg",
    size: "20×15×3 cm",
    price: "29,50€",
  },
];

export const EXAMPLE_ORIGINAL =
  "https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6939f5b5911fbf7e6ebf8768/e6514e2fa_IMG_4266.jpg";

export const WOOD_VARIANTS = [
  {
    label: "Estilo Óleo",
    image:
      "https://media.base44.com/images/public/6939f5b5911fbf7e6ebf8768/e6d0538f6_tacoblanco4.png",
  },
  {
    label: "Estilo Lápiz",
    image:
      "https://media.base44.com/images/public/6939f5b5911fbf7e6ebf8768/b4fca396d_tacoblanco5.png",
  },
  {
    label: "Estilo Acuarela",
    image:
      "https://media.base44.com/images/public/6939f5b5911fbf7e6ebf8768/d86415768_tacoblanco6.png",
  },
  {
    label: "Taco blanco 20×15×3 cm",
    image:
      "https://media.base44.com/images/public/6939f5b5911fbf7e6ebf8768/d248b2c93_taco7.png",
  },
];

export const STEPS = [
  {
    num: 1,
    title: "Elige el estilo",
    description: "Selecciona entre nuestros estilos artísticos únicos.",
    icon: "Palette",
  },
  {
    num: 2,
    title: "Sube tu foto",
    description: "Envíanos la mejor foto de tu mascota, clara y bien iluminada.",
    icon: "Upload",
  },
  {
    num: 3,
    title: "Creamos tu arte",
    description: "Nuestros diseñadores transforman tu foto en una obra maestra.",
    icon: "Package",
  },
  {
    num: 4,
    title: "Recíbelo en casa",
    description: "Tu retrato en madera blanca llega empaquetado con mimo.",
    icon: "Heart",
  },
];


export const TESTIMONIALS = [
  {
    name: "Laura M.",
    text: "De verdad, me quedé sin palabras. Han captado la mirada de mi perro tal cual es. El acabado en el taco de madera blanca queda finísimo. Parece decoración de revista.",
  },
  {
    name: "Carlos R.",
    text: "No esperaba este nivel. Pensaba que sería bonito, pero es que es espectacular. El detalle y la calidad de impresión son una pasada. Muy recomendable.",
  },
  {
    name: "Marta G.",
    text: "Fue un regalo y acabamos llorando los dos. Es mucho más que un retrato, transmite muchísimo. Se nota el mimo que le ponen.",
  },
  {
    name: "Javier L.",
    text: "Me flipó el resultado. Súper fiel a la foto pero con un toque artístico que lo hace único. Además, el formato en madera blanca queda moderno y elegante.",
  },
  {
    name: "Elena P.",
    text: "Tenía miedo de que no se pareciera del todo, pero es clavado. La expresión, los detalles… todo. Y el soporte de madera le da un rollo muy premium.",
  },
  {
    name: "David S.",
    text: "Es la segunda vez que compro y repetiré seguro. No fallan. Siempre sorprenden y siempre superan expectativas.",
  },
  {
    name: "Ana T.",
    text: "Un recuerdo precioso de mi gato. Cada vez que lo veo me saca una sonrisa. La calidad es brutal, tanto en el diseño como en la impresión.",
  },
  {
    name: "Rubén C.",
    text: "Muy top. No es el típico regalo personalizado, esto está a otro nivel. Queda genial en cualquier rincón de casa.",
  },
  {
    name: "Patricia V.",
    text: "El envío rápido, el empaquetado cuidado y el resultado increíble. Se nota que hay profesionales detrás.",
  },
  {
    name: "Sergio D.",
    text: "Lo compré sin saber muy bien cómo quedaría y me sorprendió muchísimo. Es de esas cosas que en persona ganan aún más.",
  },
  {
    name: "Claudia N.",
    text: "Todo el mundo que viene a casa pregunta por el retrato. Es súper original y queda precioso con la madera blanca.",
  },
  {
    name: "Miguel A.",
    text: "Calidad-precio inmejorable. Pensaba que sería algo más ‘normal’, pero es que parece una obra de arte en pequeño.",
  },
];
